import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getAccounting } from './accounting.selectors';

export const getAccountingAccounts = createSelector(
  getAccounting,
  ({ accounts }) => accounts || [],
);

export const getNormalizedAccountingAccounts = createSelector(
  getAccountingAccounts,
  accountingAccounts => {
    if (!accountingAccounts?.length) {
      return {};
    }

    return accountingAccounts.reduce((acc, { name, id }) => {
      acc[id] = name;

      return acc;
    }, {});
  },
);

export const getAccountById = memoizeOne(id =>
  createSelector(getAccountingAccounts, accounts => accounts?.find(item => id && item.id === id)),
);
